import { render, staticRenderFns } from "./SettingSelect.vue?vue&type=template&id=60571253&"
import script from "./SettingSelect.vue?vue&type=script&lang=js&"
export * from "./SettingSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports